export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  CANCEL_RENEWAL_PENDING: 'cancel_renewal_pending',
  CANCEL_RENEWAL: 'cancel_renewal'
};

export const MISSING_PAYMENT_EXPIRED_DAY = 60;
